/* global localStorage */
import ApiService from '@/common/api.service'

import { FECTH_TIPO_MENU, FECTH_TEMPLATE_OPTIONS, FECTH_TIPO_TEMPLATE_DESKTOP } from '@/store/actions.type'
import { SET_ERROR, SET_TIPO_MENU, SET_TEMPLATE_OPTIONS, SET_TIPO_TEMPLATE_DESKTOP } from '@/store/mutations.type'

const state = {
    menu: {},
    template: {},
    template_desktop: {},
    pageActive: null,
    errors: null
}

const getters = {
    getMenu(state) {
        return state.menu
    },
    getTemplate(state) {
        return state.template
    },
    getTemplateDesktop(state) {
        return state.template_desktop
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error
    },
    [SET_TIPO_MENU](state, payload) {
        state.menu = payload
        state.errors = {}
    },
    [SET_TEMPLATE_OPTIONS](state, payload) {
        state.template = payload
        state.errors = {}
    },
    [SET_TIPO_TEMPLATE_DESKTOP](state, payload) {
        state.template_desktop = payload
        state.errors = {}
    }
    
}

const actions = {
    [FECTH_TIPO_MENU](context) {
        if (context.menu) {
            return this.getMenu()
        }
        return new Promise((resolve) => {
            ApiService.post("dashboard/table", {
                table: 'menus',
                token: localStorage.getItem("token"),
                project_id: localStorage.getItem("table")
            }).then(response => {
                context.commit(SET_TIPO_MENU, response.data)
                resolve(response.data)
            })
            .catch((data) => {
                context.commit(SET_ERROR, data)
            })            
        })
    },
    [FECTH_TEMPLATE_OPTIONS](context) {
        if (context.template) {
            return this.getTemplate()
        }
        return new Promise((resolve) => {
            ApiService.post("dashboard/table", {
                table: 'templates',
                token: localStorage.getItem("token"),
                project_id: localStorage.getItem("table")
            }).then(response => {
                context.commit(SET_TEMPLATE_OPTIONS, response.data)
                resolve(response.data)
            })
            .catch((data) => {
                context.commit(SET_ERROR, data)
            })            
        })
    },
    [FECTH_TIPO_TEMPLATE_DESKTOP](context) {
        if (context.menu) {
            return this.getMenu()
        }
        return new Promise((resolve) => {
            ApiService.post("dashboard/table", {
                table: 'template_desktop',
                token: localStorage.getItem("token"),
                project_id: localStorage.getItem("table")
            }).then(response => {
                context.commit(SET_TIPO_TEMPLATE_DESKTOP, response.data)
                resolve(response.data)
            })
            .catch((data) => {
                context.commit(SET_ERROR, data)
            })            
        })
    },
    
}
export default {
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/pages.js